import React from 'react'
import { Image, Button } from "antd";
import MonogramIcon from "assets/images/mongram.jpg";
import { baseImageURL } from 'utils/env';
import { useGlobalMerchant } from 'utils/helper';

const ECAProductComponent = ({
  isHaveSubCategory,
  catClick,
  handleSubCategoryClick,
  filterProductList,
  addedToCart,
  handleCartAction
}: any) => {
  const { globalMerchantCurrency } = useGlobalMerchant();
  return (
    <div className="ecContainer productListWrapper">
      {isHaveSubCategory ? (
        <div className="flexWrapper">
          {catClick && catClick.sub_categories && catClick.sub_categories.length > 0 && catClick.sub_categories.map((item: any) => {
            return (
              <div className="subCatListWrapper" onClick={() => handleSubCategoryClick(item)} >
                <div className="productListImage">
                  <Image src={item.image_path !== null ? `${baseImageURL}${item.image_path}` : MonogramIcon} alt="product image" />
                </div>
                <div className="productListContent">
                  <p className="subInnerHeadingPara">{item.category_name}</p>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="productListBody">
          {filterProductList && filterProductList.map((product: any) => (
            <div key={product.product_id} className="productItemWrapper" >
              <div className="productItemInner">
                <div className="productListImage">
                  <Image src={product.img !== null ? `${baseImageURL}${product.img}` : MonogramIcon} alt="product image" />
                </div>
                <div className="productListContent">
                  <p className="subInnerHeadingPara"> {product.product_name} </p>
                  <p className="productInfo">{product.description}</p>
                </div>
                <div className="productListBottom">
                  <p className="subInnerHeading">{product.price} {globalMerchantCurrency}</p>
                  <div className="disableBtnWrapper">
                    {product.qty <= 0 ? (
                      <Button className="disableBtn"> Out Of Stock  </Button>
                    ) : (
                      <Button
                        className={addedToCart[product.product_id] ? "commonButtonSmall remove" : "commonButtonSmall add"}
                        onClick={() => handleCartAction(product.product_id, product)}
                      >
                        {addedToCart[product.product_id] ? "Remove From Cart" : "Add To Cart"}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default ECAProductComponent